import React from "react";
import styled, { css } from "react-emotion";
import PropTypes from "prop-types";
import { FlexRow, FlexColumn } from "../../app.styles";
import ReactMarkdown from "react-markdown";

const StyledStore = styled("div")`
  /* display: inline-table; */
  color: black;
  width: 100%;
  box-sizing: content-box;
  border-radius: 5px;
  text-align: center;
  margin: ${(props) => (props.margin ? props.margin : "5 0 10 0")};
  /* background: ${(props) =>
    props.background ? props.background : "#89d2d3"}; */
  background: ${(props) => (props.background ? props.background : "white")};
  border: ${(props) => "1px solid " + props.color};

  padding-top: 15px;
  padding-bottom: 15px;
  transition: transform 0.2s ease-in-out;

  &:hover {
    cursor: pointer;
    /* border: 2px solid red; */
    background: #e7e7e7;
    transform: scale(1.02);
  }
`;

const smallText = css`
  font-size: 9px;
  height: auto;
  color: black;
`;

const finePrintStyle = css`
  font-size: 9px;
  word-wrap: break-word;
  color: black;
  text-decoration: underline;
`;

const descriptionStyle = css`
  color: black;
  text-align: left;
  padding: 5px 20px;
`;

const importantNoteStyle = css`
  color: black;
  text-align: left;
  padding: 5px 20px;
  font-size: 12px;
  font-weight: normal;
`;

const formatCentsToDollars = function (value) {
  value = (value + "").replace(/[^\d.-]/g, "");
  value = parseFloat(value);
  var returnVal = value ? value / 100 : 0;
  return returnVal.toFixed(2);
};

const Store = ({
  id,
  price,
  finePrint,
  maxPurchasesTotal,
  maxPurchasesPerUser,
  usePurchasedItemsBy,
  imageUrl,
  title,
  description,
  expiration,
  retired,
  onClick,
  margin,
  border,
  importantNote,
  barColor,
}) => {
  const parsedExpiration = new Date(expiration).toLocaleDateString("en-US");
  // console.log(description);

  return (
    <StyledStore
      key={id}
      border={border}
      margin={margin}
      background={retired ? "grey" : null}
      onClick={() => onClick(id)}
      color={barColor}
    >
      {imageUrl ? (
        <div>
          <FlexRow style={{ height: "fit-content", marginBottom: "5px" }}>
            <FlexColumn>
              {" "}
              {imageUrl ? (
                <img
                  src={imageUrl}
                  width="120px"
                  height="120px"
                  style={{ borderRadius: "5px", objectFit: "cover" }}
                ></img>
              ) : null}
            </FlexColumn>
            <FlexColumn
              style={{ alignItems: "flex-start", height: "fit-content" }}
            >
              {" "}
              <h2 style={{ color: "black", textAlign: "center" }}>{title}</h2>
              {price != 0 && (
                <h3 style={{ color: "black" }}>
                  ${formatCentsToDollars(price)}
                </h3>
              )}
            </FlexColumn>
          </FlexRow>
          <FlexRow style={{ height: "auto" }}>
            <p
              style={{
                padding: "0px 15px ",
                fontWeight: "normal",
                fontSize: "14px",
              }}
              className={descriptionStyle}
            >
              {/* {description ? description.split(/\r\n|\r|\n/g).map(str => <p>{str}</p>) : null} */}
              {description ? (
                <ReactMarkdown
                  // className={styles.result}
                  source={description}
                />
              ) : null}
            </p>
          </FlexRow>
        </div>
      ) : (
        <div>
          {" "}
          <h2>{title}</h2>
          {price != 0 && (
            <h3 style={{ color: "black" }}>${formatCentsToDollars(price)}</h3>
          )}
          <h4
            style={{
              padding: "0px 15px ",
              fontWeight: "normal",
              fontSize: "14px",
            }}
            className={descriptionStyle}
          >
            {description}
          </h4>{" "}
        </div>
      )}

      <div
        style={{
          color: barColor,
          border: barColor + " 1px solid",
          width: "88%",
          padding: "10px",
          margin: "auto",
          borderRadius: "30px",
          marginBottom: "5px",
        }}
      >
        Add to Cart
      </div>

      {importantNote != "" && importantNote != null ? (
        <h4 className={importantNoteStyle}>
          Note from seller: {importantNote}
        </h4>
      ) : null}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "0px 10px",
        }}
      >
        {expiration ? (
          <p className={smallText}>Exp: {parsedExpiration}</p>
        ) : (
          <p className={smallText}></p>
        )}
        {finePrint ? (
          <p className={finePrintStyle}>Fine Print</p>
        ) : (
          <p className={finePrintStyle}></p>
        )}
      </div>
    </StyledStore>
  );
};

Store.propTypes = {
  deals: PropTypes.object,
  onClick: PropTypes.func,
};

export default Store;
